import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {environment} from "../../environments/environment";
import {parseUri} from "angular-in-memory-web-api";

@Injectable({
    providedIn: 'root'
})
export class FrontendErrorHandlingService {
    constructor(private router: Router) {}

    handleUnauthorized(url: string) {
        this.router.navigate(['/logout']);
    }

    handleForbidden(url: string) {
        this.router.navigate(['/error_403']);
    }

    handleNotFound(url: string) {
        this.router.navigate(['/error_404']);
    }

    handleInternalServerError(url: string) {
        this.router.navigate(['/error_500']);
    }

    handleError(error: any) {
        const url = parseUri(error.url);

        if ((error.url).includes("/api/")) {
            return;
        }

        if (error.status === 401) {
            this.handleUnauthorized(url.path);
        } else if (error.status === 403) {
            this.handleForbidden(url.path);
        } else if (error.status === 404) {
            this.handleNotFound(url.path);
        } else if (error.status === 500) {
            this.handleInternalServerError(url.path);
        }
    }
}
